import { connect } from "react-redux";
import ComparedTable from "./ComparedTable";
import { getProjectComparison } from "../../../../../../../../../../redux/actions";

// The list and paging only. The pairing (match mode, baseline picks) is read
// per row by ComparedRow, so a dropdown change doesn't re-render the table.
const mapStateToProps = (state) => ({
    benchmarkFiltersAnalysis: state.BenchmarkFilteringReducer.benchmarkFiltersAnalysis,
    fetchProjectComparisonApi: state.BenchmarkFilteringReducer.fetchProjectComparisonApi,
});

const mapDispatchToProps = (dispatch) => ({
    getProjectComparison: (payload) => dispatch(getProjectComparison(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ComparedTable);
